import api from 'api';
import { ConfirmButton } from 'components/common';

import type { GetUserCustomAttributesRes } from 'shared-types/responses';

interface Props {
  attribute: GetUserCustomAttributesRes['userCustomAttributes'][0];
  updateData: () => Promise<void>;
}

const UserAttributesConvertToArray = ({ attribute, updateData }: Props) => {
  const handleSubmit = async () => {
    await api.post(
      `/admin/user-custom-attributes/${attribute.id}/convert-to-array`
    );

    await updateData();

    return true;
  };

  return (
    <ConfirmButton
      actionText={'Convert'}
      buttonIcon="share"
      buttonIsDropdown={true}
      buttonText={'Convert to array'}
      category="default"
      confirmText={
        'Are you sure you want to convert the attribute type to array?'
      }
      confirmTitle={'Convert to array'}
      onConfirm={handleSubmit}
      successMessage={'Attribute converted to array successfully'}
    />
  );
};

export default UserAttributesConvertToArray;
